(function () {
  'use strict';

  // Ajustá este valor si necesitás cubrir más casos (ej: subir a 3 para incluir "d3", "b6", etc.)
  var SHORT_WORD_MAX_LENGTH = 2;

  function shouldQuote(query) {
    var trimmed = query.trim();
    if (!trimmed) return false;
    if (trimmed.charAt(0) === '"') return false; // ya viene con comillas, no duplicar

    var words = trimmed.split(/\s+/);
    if (words.length < 2) return false; // solo aplica a búsquedas de 2+ palabras

    var lastWord = words[words.length - 1];
    return lastWord.length <= SHORT_WORD_MAX_LENGTH;
  }

  function quoteQuery(query) {
    return '"' + query.trim() + '"';
  }

  // 1. Interceptar el submit del formulario de búsqueda (header, modal de búsqueda, etc.)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    var isSearchForm = form.getAttribute('role') === 'search' || form.action.indexOf('/search') !== -1;
    if (!isSearchForm) return;

    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value) return;

    if (shouldQuote(input.value)) {
      input.value = quoteQuery(input.value);
    }
  }, true);

  // 2. Red de seguridad: si se llega directo a /search?q=... sin pasar por el form
  //    (ej: "Ver todos los resultados" de Rapid Search, links externos, bookmarks)
  if (window.location.pathname.indexOf('/search') === 0) {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');

    if (q && shouldQuote(q)) {
      params.set('q', quoteQuery(q));
      window.location.replace(window.location.pathname + '?' + params.toString());
    }
  }
})();